import { useState } from 'react';
import { useRouter } from 'next/router';

import Layout from '@layout/index';
import MortgageCalculatorEnhanced from '@components/calculators/mortgage-calculator-enhanced';
import AffordabilityCalculator from '@components/calculators/affordability-calculator';
import RefinanceCalculator from '@components/calculators/refinance-calculator';
import RentVsBuyCalculator from '@components/calculators/rent-vs-buy-calculator';
import interestRatesData from '@data/interest-rates.json';

const RentVsBuyCalculatorPage = () => {
  const router = useRouter();
  const [currentCalculator, setCurrentCalculator] = useState('rent-vs-buy');

  const calculatorOptions = [
    { label: 'Mortgage calculator', value: 'mortgage' },
    { label: 'Affordability calculator', value: 'affordability' },
    { label: 'Refinance calculator', value: 'refinance' },
    { label: 'Rent vs. buy calculator', value: 'rent-vs-buy' }
  ];

  const currentRates = {
    15: interestRatesData['15'],
    30: interestRatesData['30']
  };

  const lastUpdatedOn = interestRatesData.lastUpdatedOn;

  const handleCalculatorChange = (calculatorType) => {
    setCurrentCalculator(calculatorType);
    router.push(`/calculators/${calculatorType}`, undefined, { shallow: true });
  };

  const renderCalculator = () => {
    switch (currentCalculator) {
      case 'affordability':
        return (
          <AffordabilityCalculator
            calculatorOptions={calculatorOptions}
            onCalculatorChange={handleCalculatorChange}
            currentRates={currentRates}
          />
        );
      case 'refinance':
        return (
          <RefinanceCalculator
            calculatorOptions={calculatorOptions}
            onCalculatorChange={handleCalculatorChange}
            currentRates={currentRates}
          />
        );
      case 'mortgage':
        return (
          <MortgageCalculatorEnhanced
            calculatorOptions={calculatorOptions}
            onCalculatorChange={handleCalculatorChange}
            currentRates={currentRates}
            lastUpdatedOn={lastUpdatedOn}
          />
        );
      case 'rent-vs-buy':
      default:
        return (
          <RentVsBuyCalculator
            calculatorOptions={calculatorOptions}
            onCalculatorChange={handleCalculatorChange}
            currentRates={currentRates}
          />
        );
    }
  };

  return (
    <Layout
      metaData={{
        title: 'Rent vs. Buy Calculator | Sibcy Cline',
        description:
          'Compare the long-term costs of renting versus buying a home. Factor in mortgage payments, appreciation, maintenance, and opportunity costs.'
      }}
    >
      {renderCalculator()}
    </Layout>
  );
};

export default RentVsBuyCalculatorPage;
